import { useAppSelector } from "../../../../lib/redux/hooks"
import { BusinessRegisterRequestMotivationOptions, BusinessRegisterTypologyRequestOptions, formatterDate, optionsFormatter } from "../../../../utils"

export function ReportRegistriAziendaliList() {
    const registerState = useAppSelector(state => state.register)

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm bg-white">
            <table className="w-full border-collapse text-sm">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Sede</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Ragione Sociale</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Cliente</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Motivo Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Rilascio</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Rilascio</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Note</th>
                    </tr>
                </thead>
                <tbody>
                    {(registerState.getAllBusinessRegistersResponse?.data ?? []).length === 0 ? (
                        <tr>
                            <td colSpan={13} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                Nessun registro trovato
                            </td>
                        </tr>
                    ) : (
                        (registerState.getAllBusinessRegistersResponse?.data ?? []).map((regAz, index) =>
                            <tr
                                key={regAz.id || index}
                                className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                            >
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.headQuarterInfo?.code || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.customerCountryRegion || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.customerCompanyName || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.customerClientCode || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(regAz.requestDate)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{optionsFormatter(regAz.requestReason, BusinessRegisterRequestMotivationOptions)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.requestProtocolInfo || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{optionsFormatter(regAz.requestType, BusinessRegisterTypologyRequestOptions)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(regAz.releaseDate)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.releaseProtocolInfo || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                    {regAz.addedRegistersInfo?.length ? regAz.addedRegistersInfo.map((reg, regIndex) => (
                                        <p key={`${reg.progressive}-${regIndex}`}>{reg.progressive}</p>
                                    )) : '-'}
                                </td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                    {regAz.addedRegistersInfo?.length ? regAz.addedRegistersInfo.map((reg, regIndex) => (
                                        <p key={`${reg.name}-${regIndex}`}>{reg.name}</p>
                                    )) : '-'}
                                </td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.note || '-'}</td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    )
}